import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export const InfoTip = ({ text }) => (
  <TooltipProvider delayDuration={100}>
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          data-testid="info-tip"
          onClick={(e) => e.preventDefault()}
          className="inline-flex text-muted-foreground/50 transition-colors hover:text-foreground"
        >
          <Info className="h-3.5 w-3.5" />
        </button>
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-[240px] text-xs font-normal normal-case leading-relaxed tracking-normal">
        {text}
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
